/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ rate: NonNullable<unknown> }} Seo_Rate_KeywordsInputs */

const en_seo_rate_keywords = /** @type {(inputs: Seo_Rate_KeywordsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.rate} per 1,000 keywords`)
};

const zh_hans1_seo_rate_keywords = /** @type {(inputs: Seo_Rate_KeywordsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`每千个关键词 ${i?.rate}`)
};

const pt_br2_seo_rate_keywords = /** @type {(inputs: Seo_Rate_KeywordsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.rate} por mil palavras-chave`)
};

const es_seo_rate_keywords = /** @type {(inputs: Seo_Rate_KeywordsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.rate} por cada 1,000 palabras clave`)
};

const fr_seo_rate_keywords = /** @type {(inputs: Seo_Rate_KeywordsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.rate} pour 1 000 mots-clés`)
};

const de_seo_rate_keywords = /** @type {(inputs: Seo_Rate_KeywordsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.rate} pro 1.000 Keywords`)
};

const ru_seo_rate_keywords = /** @type {(inputs: Seo_Rate_KeywordsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.rate} за 1000 ключевых слов`)
};

const it_seo_rate_keywords = /** @type {(inputs: Seo_Rate_KeywordsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.rate} ogni 1.000 parole chiave`)
};

/**
* | output |
* | --- |
* | "{rate} per 1,000 keywords" |
*
* @param {Seo_Rate_KeywordsInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const seo_rate_keywords = /** @type {((inputs: Seo_Rate_KeywordsInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Rate_KeywordsInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_seo_rate_keywords(inputs)
	if (locale === "pt-BR") return pt_br2_seo_rate_keywords(inputs)
	if (locale === "es") return es_seo_rate_keywords(inputs)
	if (locale === "fr") return fr_seo_rate_keywords(inputs)
	if (locale === "de") return de_seo_rate_keywords(inputs)
	if (locale === "ru") return ru_seo_rate_keywords(inputs)
	if (locale === "it") return it_seo_rate_keywords(inputs)
	return en_seo_rate_keywords(inputs)
});